var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.item
    ? _c(
        "div",
        { staticClass: "item-view" },
        [
          _vm.item
            ? [
                _c("div", { staticClass: "item-view-header" }, [
                  _c("a", { attrs: { href: _vm.item.url, target: "_blank" } }, [
                    _c("h1", [_vm._v(_vm._s(_vm.item.evpaName))]),
                  ]),
                  _vm._v(" "),
                  _vm.item.url
                    ? _c("span", { staticClass: "host" }, [
                        _vm._v(
                          "\n\t\t\t\t(" +
                            _vm._s(_vm._f("host")(_vm.item.url)) +
                            ")\n\t\t\t"
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "meta" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.item.evpaBIBNo) +
                        "\n\t\t\t\t| " +
                        _vm._s(_vm.item.evpaGender) +
                        " --\n\t\t\t\t" +
                        _vm._s(_vm._f("timeAgo")(_vm.item.evpaCreatedTime)) +
                        " ago\n\t\t\t"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item-view-comments" }, [
                  _c(
                    "p",
                    { staticClass: "item-view-comments-header" },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.item.kids
                              ? _vm.item.descendants + " comments"
                              : "No comments yet."
                          ) +
                          "\n\t\t\t\t"
                      ),
                      _c("spinner", { attrs: { show: _vm.loading } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.loading
                    ? _c(
                        "ul",
                        { staticClass: "comment-children" },
                        _vm._l(_vm.item.kids, function (id) {
                          return _c("comment", { key: id, attrs: { id: id } })
                        }),
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/ItemView.vue